











































import moment from 'moment'
import { computed, defineComponent } from '@vue/composition-api'
import { IQuestionnaire, publicationName } from '@/types/questionnaire'
import { supplierName } from '@/types/receipt'

type Props = {
  questionnaires: IQuestionnaire[]
  isAutomatic: boolean
  loading: boolean
}

export default defineComponent({
  name: 'QuestionnaireTable',
  props: {
    questionnaires: {
      type: Array,
      default: () => [],
    },
    isAutomatic: { type: Boolean },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  setup(props: Props) {
    const headers = [
      { text: '作成者ID', value: 'createdById' },
      { text: 'アンケートID', value: 'id' },
      { text: '管理名', value: 'nameAdmin' },
      { text: 'アンケート名', value: 'name' },
      { text: 'サービス名', value: 'targetSupplier' },
      { text: '状態', value: 'status' },
      { text: '公開日時', value: 'releaseAt' },
      { text: '終了日時', value: 'finishAt' },
      { text: props.isAutomatic ? '総募集数' : '募集数', value: 'totalLimit' },
      { text: '総配布数', value: 'total' },
      { text: '総回答数', value: 'totalAnswered' },
      { text: 'チェック数', value: 'totalChecked' },
      { text: 'Adminチェック数', value: 'totalAdminChecked' },
      { text: '設定', value: 'settings' },
      { text: 'プレビュー', value: 'preview' },
      { text: '集計情報', value: 'totalling' },
    ]

    const items = computed(() =>
      props.questionnaires.map(q => ({
        ...q,
        releaseAt: q.releaseAt
          ? moment(q.releaseAt).format('YYYY/MM/DD HH:mm')
          : '未設定',
        finishAt: q.finishAt
          ? moment(q.finishAt).format('YYYY/MM/DD HH:mm')
          : '未設定',
        targetSupplier: supplierName(q.targetSupplier),
        status: publicationName(q.status),
        totalLimit: q.totalLimit === null ? '-' : q.totalLimit,
      })),
    )

    const qType = props.isAutomatic ? 'automatic' : 'manual'

    return { props, headers, moment, items, qType }
  },
})
